/**
 * Backend error messages recognized by `useHandleSpecialBackendErrors`.
 * Each project decides via `ProjectRuntimeBehavior.shouldShowUpgradePaywallOnHandledBackendError`
 * which of these (if any) should bypass the shared modal switch and open
 * the project's upgrade paywall instead.
 */
export enum HANDLED_BACKED_ERRORS {
  SUBSCRIPTION_IS_NOT_ACTIVE = 'Subscription is not active',
  SUBSCRIPTION_IS_CANCELED = 'Subscription is canceled',
  SUBSCRIPTION_IS_EXPIRED = 'Subscription is expired',
  SUBSCRIPTION_IS_IN_REDEMPTION = 'Subscription is in redemption',
  SUBSCRIPTION_PAYMENT_IS_PROCESS = 'Subscription payment in process',
  SUBSCRIPTION_REDEMPTION_PAYMENT_FAILED = 'Subscription redemption payment failed',
  SUBSCRIPTION_IS_ON_PAUSE = 'Subscription is on pause',
  FREE_TIER_DAILY_LIMIT_EXCEEDED = 'Free tier daily limit exceeded',
}
